import { render, staticRenderFns } from "./licenses-view.vue?vue&type=template&id=2d5efe86&"
import script from "./licenses-view.vue?vue&type=script&lang=js&"
export * from "./licenses-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports